<template>
    <nav class="mobile-menu">
      <button @click="showMenu=!showMenu" class="mobile-menu__btn">
        <div :class="['mobile-menu__icon', {iconActive:showMenu}]"></div>
      </button>
      <!-- <img v-if="enterPoint==='test' || enterPoint==='local'" :src="require('@/assets/img/logo.png')" alt="logo" width="40px" > -->
      <img :src="require('@/assets/img/Logo-mini.png')" alt="logo" width="35px" >
      <div></div>
      <div :class="['mobile-menu__container', showMenu ? 'mobileMenuActive' : null]">
        <ul class="mobile-menu__list">
            <li class="mobile-menu__item"
            @click="showMenu=false"
            v-for="(route, index) in routes" :key="index"
            >
              <router-link class="mobile-menu__link" :to="route.path">
                <el-badge :hidden="badgeContent(route)===0" :value="badgeContent(route)">
                  <i :class="route.meta.icon"></i>
                </el-badge>
                <span>{{route.meta.title}}</span>
              </router-link>
            </li>
            <li @click="signOut()" class="mobile-menu__item">
                <div class="mobile-menu__link">
                  <i class="fas fa-sign-out-alt"></i>
                  <span>Выход</span>
                </div>
            </li>
        </ul>
      </div>
  </nav>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  data() {
    return {
      enterPoint:'',
      routes:[],
      showMenu:false,
      user:{
          name: 'noname',
          id: 0,
          properties:{
              countUnreadMsg: '',
              countDisciplines: '',
              countUntestedWorks: ''
          }
      },
    }
  },
  methods: {
      ...mapActions({
        signOut : 'auth/signOut',
        guardian: 'guardian'
      }),
      badgeContent(value){
          if(value.name==='Messages'){
              return this.user.properties.countUnreadMsg
          }else if(value.name==='tresult'){
              return this.user.properties.countUntestedWorks
          }else if(value.name==='Docs'){
              return this.$store.getters['docs/unviewedCount']
          }
      },
  },
  mounted() {
    console.log('window.location.origin', window.location.origin)
    this.enterPoint = this.globalFunctions.setEnterPoint(window.location.origin).name
    this.$router.options.routes.forEach(el=>{
            el.meta.nav ? this.routes.push(el) : null
        })
    this.axios.get('api/properties').then(response=>{
              this.$store.commit('setUserData', response.data)
            this.user.properties = response.data
            this.user.name = this.$store.state.auth.user.name
            //this.user.id = this.$store.state.auth.user.id
          })
  },
}
</script>
<style lang="scss">
  .mobile-menu {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: grid;
    grid-template-columns: 40px auto 40px;
    align-items: center;
    justify-items: center;
    padding: 0 16px;
    background-color: $brand-clr-1;
    height: 50px;
    z-index: 20;
  }
  .mobile-menu__btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 30px;
    cursor: pointer;
    transition: .4s;
    padding: 0;
  }
  .mobile-menu__icon {
    display: block;
    position: relative;
    background: white;
    width: 90%;
    height: 4px;
    transition: .4s;
  }
  .mobile-menu__icon::after, .mobile-menu__icon::before {
    content: "";
    display: block;
    position: absolute;
    background: white;
    width: 100%;
    height: 4px;
    transition: .4s;
  }
  .mobile-menu__icon::after {
    top: 8px;
  }
  .mobile-menu__icon::before {
    top: -8px;
  }
  .mobile-menu__container {
    position: fixed;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 999;
    height: 0;
    opacity: 1;
    transition: .5s;
    overflow: hidden;
    background-color: $brand-clr-1;
  }
  .mobile-menu__list {
    width: 100%;
    transition: .5s;
    list-style: none;
    padding-left: 0;
    margin-top: -50px;
  }
  .mobile-menu__item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    padding: 15px 20px;
    &:active{
      background-color: lighten($color: $brand-clr-1, $amount: 20%);
    }
  }
  .el-badge{
    font-size: inherit;
  }
  .mobile-menu__link {
    width: 100%;
    display: grid;
    grid-template-columns: 30px auto 30px;
    align-items: center;
    text-decoration: none;
    color: #fff;
    font-size: inherit;
    span{
      font-size: inherit;
    }
    i{
      justify-self: center;
      font-size: inherit;
    }
  }
  .mobile-menu__checkbox {
    display: none;
  }
  .mobile-menu__checkbox:checked ~ .mobile-menu__nav {
    opacity: 1;
  }
  .mobileMenuActive{
    height: 100%;
  }
  .iconActive {
    background: transparent;
  }
  .iconActive::before,
  .iconActive::after {
    top: 0;
  }
  .iconActive::after {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .iconActive::before {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

</style>
